import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { useStore } from "./Store";
import { useEffect, useRef } from "react";
import type { JamEvent } from "./jam";


const MapMarker: React.FC<{ item: JamEvent, selected: boolean }> = ({ item, selected }) => {
  const { store, selectJam } = useStore();

  const ref = useRef<L.Marker | null>(null);

  ref.current?.setOpacity(selected ? 1 : .5);
  if (!store.loaded) return null;

  return <Marker
    ref={ref}
    position={[item.venue.latitude, item.venue.longitude]}
    opacity={.5}
    eventHandlers={{
      click: () => {
        if (!store) return;
        selectJam(item.id);
      },
    }}
  />
};

const Map: React.FC = () => {
  const { store } = useStore();
  return (
    <MapContainer className="h-100" center={[52.505, -1.09]} zoom={7} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {
        store.loaded && store.jams.map((item, index) => {
          return <MapMarker
            key={index}
            selected={item.id === store.selected?.id}
            item={item}
          />
        })
      }
    </MapContainer>
  )
};

export default Map;
